export const MOVE_CONTENT = 'MOVE_CONTENT';
export const moveContent = value => ({ type: MOVE_CONTENT, value });

export const MOVE_COMPONENT = 'MOVE_COMPONENT';
export const moveComponent = value => ({ type: MOVE_COMPONENT, value });

export const CONTENT_DID_DROP = 'CONTENT_DID_DROP';
export const contentDidDrop = value => ({ type: CONTENT_DID_DROP, value });



// WEBPACK FOOTER //
// ./src/actions/contentMove.js